import IvrSingleMessageItem from '@/components/Projects/Common/IvrSingleMessageItem';

// @vue/component
export default {
  name: 'IvrBasicMessagesList',

  components: {
    IvrSingleMessageItem,
  },

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
    lang: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    messages: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      prefix: '',
      isSecondLanguage: false,
    };
  },

  created() {
    // ze względu na to, że bazie danych kolumny odpowiedzialne za drugi język mają prefix '_en' - no cóż :/
    if (this.lang === 'second') {
      this.prefix = '_en';
      this.isSecondLanguage = true;
    }
  },
};
